import { ElementRef, Directive, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';

declare function require(name: string): any;
declare var $: any;

@Directive({
    selector: '[gawebBusyMessage]'
})
export class BusyMessageDirective implements OnInit {
    @Input() busyMsg: string;

    constructor(private _element: ElementRef) {
        this.busyMsg = '<i class=\'fa fa-refresh fa-spin\'></i> Processing...';
    }

    ngOnInit() {
        const msg = this.busyMsg;

        $(this._element.nativeElement).on('click', function () {
            $(this).html(msg);
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/busymessage/busymessage.directive.ts